import { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ToastContainer from "../components/common/ToastContainer";
import { useNavigate } from "react-router-dom";
import SiteAlert from "../components/common/SiteAlert";
import { showWarningAlert } from "../redux/action/alertActions";
import PrintComponent from "../components/PrintComponent";
import KOTPrintComponent from "../components/KOTcomponent/index";

const UtilComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isExpired = useSelector((state) => state.user.hasSubscriptionExpired);
  const isLogged = useSelector((state) => state.user.isLogged);
  const isElectron = window?.api?.isElectron;

  const { enablePrinting, enableKOT, printData, KOTprintData } = useSelector(
    (state) => state.util,
  );

  useEffect(() => {
    if (isExpired && isLogged) {
      navigate("/expired");
    }
  }, [isExpired, isLogged]);

  useEffect(() => {
    const nativeAlert = window.alert.bind(window);
    window.alert = (data) => {
      setTimeout(() => dispatch(showWarningAlert(data)), 0);
    };
    return () => {
      window.alert = nativeAlert;
    };
  }, [dispatch]);

  useEffect(() => {
    if (!isElectron) return;
    window.addEventListener("online", window.api.updateOnlineStatus);
    window.addEventListener("offline", window.api.updateOnlineStatus);
    return () => {
      window.removeEventListener("online", window.api.updateOnlineStatus);
      window.removeEventListener("offline", window.api.updateOnlineStatus);
    };
  }, [isElectron]);

  return (
    <Fragment>
      {enablePrinting && printData && <PrintComponent />}
      {enableKOT && KOTprintData && <KOTPrintComponent />}

      <ToastContainer />
      <SiteAlert />
    </Fragment>
  );
};

export default UtilComponent;
